<template>
  <div class="gx-tk">
    <!-- <h1 class="gx-main__title">工单管理</h1> -->

    <!-- 顶部 Tab -->
    <div class="gx-tk__tabs">
      <button
        v-for="t in topTabs"
        :key="t.id"
        class="gx-tk__tab"
        :class="{ 'gx-tk__tab--on': topTab === t.id }"
        @click="switchTopTab(t.id)"
      >
        {{ t.label }}
      </button>
    </div>

    <!-- 我的工单 / 工单管理 -->
    <template v-if="topTab !== 'create'">
      <div class="gx-tk__status-tabs">
        <button
          v-for="s in statusTabs"
          :key="s.status"
          class="gx-tk__status-tab"
          :class="[{ 'gx-tk__status-tab--on': activeStatus === s.status },statusTabClass(s.status)]"
          @click="switchStatus(s.status)"
        >
          {{ s.label }}<span class="gx-tk__status-num">{{ s.count }}</span>
        </button>
      </div>

      <!-- 筛选 -->
      <div class="gx-tk__filter">
        <!-- <label class="gx-tk__flabel">创建时间</label>
        <input v-model="timeStart" type="datetime-local" class="gx-tk__input gx-tk__input--mi gx-tk__input--date" @change="onTimeChange" />
        <span class="gx-tk__range-sep">至</span>
        <input v-model="timeEnd" type="datetime-local" class="gx-tk__input gx-tk__input--mi gx-tk__input--date" @change="onTimeChange" />
        <input v-model="searchData.ticket_sn" class="gx-tk__input gx-tk__input--mi" placeholder="工单编号" @keyup.enter="search" />
        <input v-model="searchData.title" class="gx-tk__input gx-tk__input--mi" placeholder="工单标题" @keyup.enter="search" /> -->

         <div class="search-wrap custom-form-wrap">
              <el-form inline size="mini" :model="searchData" ref="searchForm">
                <el-form-item label="工单编号">
                  <el-input v-model="searchData.ticket_sn" clearable placeholder="请输入工单编号"></el-input>
                </el-form-item>
                  <el-form-item label="工单标题">
                  <el-input v-model="searchData.title" clearable placeholder="请输入工单标题"></el-input>
                </el-form-item>
                <el-form-item label="创建时间">
                  <el-date-picker class="w320"
                      v-model="searchData.timeRange"
                      type="datetimerange"
                      align="right"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="pickerOptions"
                      @change="onTimeChange"
                      :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </div>




        <button class="gx-tk__btn gx-tk__btn--mi gx-tk__btn--yellow" @click="search">查询</button>
        <button class="gx-tk__btn gx-tk__btn--mi" @click="resetSearch">重置</button>
        <div class="gx-tk__spacer"></div>
        <button class="gx-tk__btn gx-tk__btn--sm gx-tk__btn--add" @click="switchTopTab('create')">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" /></svg>
          创建工单
        </button>
      </div>

      <!-- 表格 -->
      <div class="gx-tk__card">
        <div class="gx-tk__table">
          <table>
            <thead>
              <tr>
                <th>工单编号</th>
                <th>工单标题</th>
                <th>类型</th>
                <th>状态</th>
                <th>创建时间</th>
                <th style="width: 100px">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in list" :key="row.id">
                <td class="gx-tk__mono" style="color: rgb(22, 119, 255);">{{ row.ticket_sn }}</td>
                <td class="gx-tk__td-title">{{ row.title }}</td>
                <td><span class="gx-tk__type-tag">{{ row.ticket_type_name }}</span></td>
                <td><span class="gx-tk__status" :class="statusClass(row.status)"><span class="gx-tk__status-dot"></span>{{ statusName(row.status) }}</span></td>
                <td class="gx-tk__mono gx-tk__dim">{{ row.created_at }}</td>
                <td><button class="gx-tk__link" @click="openDetail(row)">详情</button></td>
              </tr>
              <tr v-if="!list.length">
                <td colspan="6" class="gx-tk__empty">暂无工单数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div class="gx-tk__pager">
          <div class="gx-tk__pager-left">
            <span class="gx-tk__pager-total">共 {{ pageData.total }} 条</span>
            <page-size-select :value="pageData.limit" :options="pageSizeOptions" @change="onPageSizeChange" />
          </div>
          <div class="gx-tk__pager-btns">
            <button class="gx-tk__page" :disabled="pageData.page <= 1" @click="getList(pageData.page - 1)">上一页</button>
            <button v-for="n in pageNums" :key="n" class="gx-tk__page" :class="{ 'gx-tk__page--on': n === pageData.page }" @click="getList(n)">{{ n }}</button>
            <button class="gx-tk__page" :disabled="pageData.page >= totalPages" @click="getList(pageData.page + 1)">下一页</button>
          </div>
        </div> -->
      <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getList(pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
      </div>


    </template>

    <!-- 创建工单 -->
    <template v-else>
      <div class="gx-tk__steps">
        <div class="gx-tk__step" :class="{ 'gx-tk__step--on': createStep === 0, 'gx-tk__step--done': createStep > 0 }">
          <span class="gx-tk__step-num">{{ createStep > 0 ? '✓' : '1' }}</span>
          <span class="gx-tk__step-label">选择问题类型</span>
        </div>
        <div class="gx-tk__step-line" :class="{ 'gx-tk__step-line--on': createStep > 0 }"></div>
        <div class="gx-tk__step" :class="{ 'gx-tk__step--on': createStep === 1 }">
          <span class="gx-tk__step-num">2</span>
          <span class="gx-tk__step-label">填写工单信息</span>
        </div>
      </div>

      <!-- 第一步：选择问题类型 -->
      <div v-if="createStep === 0">
        <div class="gx-tk__type-title">请选择您的问题类型：</div>
        <div class="gx-tk__type-grid">
          <div
            v-for="item in typeList"
            :key="item.id"
            class="gx-tk__type-card"
            :class="{ 'gx-tk__type-card--on': selectType.id === item.id }"
            @click="selectType = item"
          >
              <!-- <div class="gx-tk__type-check">
                <svg v-if="selectType.id === item.id" width="10" height="10" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </div> -->
              <div v-if="item.dictionary_name=='店铺数据'" class="gx-tk__type-icon">🏪</div>
              <div v-if="item.dictionary_name=='商品数据'" class="gx-tk__type-icon">📦</div>
              <div v-if="item.dictionary_name=='检测数据'" class="gx-tk__type-icon">🔍</div>
              <div v-if="item.dictionary_name=='商品优化'" class="gx-tk__type-icon">✨</div>
              <div v-if="item.dictionary_name=='盲盒铺货'" class="gx-tk__type-icon">🎁</div>
              <div v-if="item.dictionary_name=='订单数据'" class="gx-tk__type-icon">📋</div>
              <div v-if="item.dictionary_name=='售后数据'" class="gx-tk__type-icon">🔄</div>
              <div v-if="item.dictionary_name=='采购数据'" class="gx-tk__type-icon">🛒</div>
              <div v-if="item.dictionary_name=='费用数据'" class="gx-tk__type-icon">💰</div>
              <div v-if="item.dictionary_name=='其他数据'" class="gx-tk__type-icon">❓</div>
              <div class="gx-tk__type-name">{{ item.dictionary_name }}</div>
              <div class="gx-tk__type-desc">{{ item.remark }}</div>
            </div>
            <div v-if="!typeList.length" class="gx-tk__empty gx-tk__type-empty">暂无问题类型</div>
          </div>
        </div>

      <!-- 第二步：填写工单 -->
      <div v-else>
        <!-- 已选问题类型 -->
        <div class="gx-tk__picked">
          <div class="gx-tk__picked-left">
            <span class="gx-tk__picked-icon">
              <span v-if="selectType.dictionary_name=='店铺数据'">🏪</span>
              <span v-else-if="selectType.dictionary_name=='商品数据'">📦</span>
              <span v-else-if="selectType.dictionary_name=='检测数据'">🔍</span>
              <span v-else-if="selectType.dictionary_name=='商品优化'">✨</span>
              <span v-else-if="selectType.dictionary_name=='盲盒铺货'">🎁</span>
              <span v-else-if="selectType.dictionary_name=='订单数据'">📋</span>
              <span v-else-if="selectType.dictionary_name=='售后数据'">🔄</span>
              <span v-else-if="selectType.dictionary_name=='采购数据'">🛒</span>
              <span v-else-if="selectType.dictionary_name=='费用数据'">💰</span>
              <span v-else>📛</span>
            </span>
            <span class="gx-tk__picked-name">{{ selectType.dictionary_name }}</span>
            <span class="gx-tk__picked-desc">{{ selectType.remark }}</span>
          </div>
          <button class="gx-tk__picked-reselect" @click="createStep = 0">重选</button>
        </div>

        <div class="gx-tk__form-card">
          <div class="gx-tk__field">
            <label class="gx-tk__flabel2"><span class="gx-tk__req">*</span> 工单标题</label>
            <input v-model="form.title" class="gx-tk__input gx-tk__input--block" placeholder="请简洁描述您的问题" />
          </div>
          <div class="gx-tk__field">
            <label class="gx-tk__flabel2">问题描述</label>
            <div class="gx-tk__textarea-wrap">
              <textarea v-model="form.content" class="gx-tk__textarea gx-tk__textarea--block" rows="6" maxlength="500" placeholder="请详细描述您的问题，包括操作步骤、报错信息等，有助于我们更快解决..."></textarea>
              <span class="gx-tk__textarea-count">{{ (form.content || '').length }}/500</span>
            </div>
          </div>
          <div class="gx-tk__field gx-tk__field--last">
            <label class="gx-tk__flabel2">附件截图</label>
            <div class="gx-tk__create-upload">
              <div v-for="(f, i) in fileList" :key="'c-thumb-'+i" class="gx-tk__create-thumb">
                <img v-if="isImage(f.url)" :src="f.url" alt="" @click="previewImg(f.url)" />
                <span v-else class="gx-tk__create-thumb-file" @click="downloadFile(f)">📄</span>
                <button class="gx-tk__create-thumb-del" @click="removeFile(i)">
                  <svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M1 1l8 8M9 1L1 9" stroke="#fff" stroke-width="1.4" stroke-linecap="round" /></svg>
                </button>
              </div>
              <label v-if="fileList.length < 5" class="gx-tk__create-add">
                <input type="file" multiple :accept="acceptTypes" style="display:none" @change="onFilesChange" :disabled="uploading" />
                <svg v-if="!uploading" width="16" height="16" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="#B0B0B5" stroke-width="1.4" stroke-linecap="round" /></svg>
                <span v-else class="gx-tk__create-uploading">...</span>
                <span class="gx-tk__create-add-text">{{ uploading ? '上传中' : '上传' }}</span>
              </label>
              <span class="gx-tk__create-upload-tip">{{ fileList.length }}/5</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 创建工单按钮区 -->
      <div class="gx-tk__form-actions">
        <template v-if="createStep === 0">
          <button class="gx-tk__btn" @click="switchTopTab('list')">取消</button>
          <button class="gx-tk__btn gx-tk__btn--primary" :disabled="!selectType.id" @click="nextStep">下一步 →</button>
        </template>
        <template v-else>
          <button class="gx-tk__btn gx-tk__btn--back" @click="createStep = 0">
            ← 上一步
          </button>
          <button class="gx-tk__btn" @click="switchTopTab('list')">取消</button>
          <button class="gx-tk__btn gx-tk__btn--primary" :disabled="saving || !form.title" @click="submitTicket">
            {{ saving ? '提交中...' : '提交工单' }}
            <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2 6.5l3 3 5-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </template>
      </div>
    </template>

    <!-- 工单详情弹窗 -->
    <div v-if="detailShow" class="gx-tk__modal" @click.self="closeDetail">
      <div class="gx-tk__modal-box gx-tk__modal-box--wide">
        <!-- 标题栏 -->
        <div class="gx-tk__modal-head">
          <div class="gx-tk__modal-head-left">
            <span class="gx-tk__modal-bar"></span>
            <span class="gx-tk__modal-title">工单详情</span>
            <span v-if="ticketInfo" class="gx-tk__modal-status" :class="statusClass(ticketInfo.status)">
              <span class="gx-tk__modal-status-dot"></span>{{ statusName(ticketInfo.status) }}
            </span>
          </div>
          <div class="gx-tk__modal-head-right">
            <button v-if="isComfigReply" class="gx-tk__head-btn gx-tk__head-btn--primary" @click="finishTicket(3)">待确认工单</button>
            <button v-if="canReply" class="gx-tk__head-btn gx-tk__head-btn--secondary" @click="finishTicket(4)">完结工单</button>
            <button class="gx-tk__modal-close" @click="closeDetail">
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M1 1l11 11M12 1L1 12" stroke="#4A4A6A" stroke-width="1.5" stroke-linecap="round" /></svg>
            </button>
          </div>
        </div>
        <div class="gx-tk__modal-body">
          <div v-if="ticketInfo" class="gx-tk__detail">
            <!-- 基础信息 -->
            <div class="gx-tk__info-card">
              <div class="gx-tk__info-grid">
                <div class="gx-tk__info-row">
                  <span class="gx-tk__info-k">处理状态</span>
                  <span class="gx-tk__info-v" :class="statusClass(ticketInfo.status)">
                    <span class="gx-tk__info-dot"></span>{{ statusName(ticketInfo.status) }}
                  </span>
                </div>
                <div class="gx-tk__info-row">
                  <span class="gx-tk__info-k">创建时间</span>
                  <span class="gx-tk__info-v">{{ ticketInfo.created_at }}</span>
                </div>
                <!-- <div class="gx-tk__info-row">
                  <span class="gx-tk__info-k">工单账号</span>
                  <span class="gx-tk__info-v">{{ ticketInfo.account || '--' }}</span>
                </div> -->
                <div class="gx-tk__info-row">
                  <span class="gx-tk__info-k">星好货账号</span>
                  <span class="gx-tk__info-v">{{ ticketInfo.user_mobile || '--' }}</span>
                </div>
                <div class="gx-tk__info-row">
                  <span class="gx-tk__info-k">工单号</span>
                  <span class="gx-tk__info-v gx-tk__info-v--link">{{ ticketInfo.ticket_sn || '--' }}</span>
                </div>
                <div class="gx-tk__info-row">
                  <span class="gx-tk__info-k">工单标题</span>
                  <span class="gx-tk__info-v">{{ ticketInfo.title }}</span>
                </div>
                <div v-if="ticketInfo.effect_no" class="gx-tk__info-row">
                  <span class="gx-tk__info-k">问题单号</span>
                  <span class="gx-tk__info-v">{{ ticketInfo.effect_no }}</span>
                </div>
                <div v-if="ticketInfo.finish_time" class="gx-tk__info-row">
                  <span class="gx-tk__info-k">完结时间</span>
                  <span class="gx-tk__info-v">{{ ticketInfo.finish_time }}</span>
                </div>
              </div>
            </div>

            <!-- 沟通记录 -->
            <div class="gx-tk__section-title">
              <span class="gx-tk__section-bar"></span>
              沟通记录 <span class="gx-tk__section-count">共{{ msgList.length }}条</span>
            </div>
            <div class="gx-tk__chat-list">
              <div
                v-for="msg in msgList"
                :key="msg.id"
                class="gx-tk__chat-item"
                :class="msg.sender_type == 1 ? 'gx-tk__chat-item--user' : 'gx-tk__chat-item--agent'"
              >
                <div class="gx-tk__chat-bubble">
                  <div class="gx-tk__chat-head">
                  <span class="gx-tk__chat-name">{{ msg.sender_name || (msg.sender_type == 1 ? '用户' : '客服小助手') }}</span>
                  <span class="gx-tk__chat-time">{{ msg.created_at }}</span>
                </div>


                  <p>{{ msg.content }}</p>
                  <div v-if="msg.attachments && msg.attachments.length" class="gx-tk__chat-att">
                    <template v-for="(att, i) in msg.attachments">
                      <img v-if="isImage(att.object_name)" :key="'img'+i" :src="att.url" class="gx-tk__att-img" alt="" @click="previewImg(att.url)" />
                      <span v-else :key="'file'+i" class="gx-tk__att-file" @click="downloadFile(att)">📄 {{ att.object_name }}</span>
                    </template>
                  </div>
                </div>
              </div>
              <div v-if="!msgList.length" class="gx-tk__empty gx-tk__chat-empty">暂无沟通记录</div>
            </div>

            <!-- 回复 -->
            <div v-if="canReply" class="gx-tk__reply">
              <div class="gx-tk__section-title">
                <span class="gx-tk__section-bar"></span>
                回复工单
              </div>
              <div class="gx-tk__reply-textarea-wrap">
                <textarea
                  ref="replyInput"
                  v-model="replyContent"
                  class="gx-tk__reply-textarea"
                  rows="4"
                  maxlength="300"
                  placeholder="输入回复内容（最多300字）..."
                ></textarea>
                <span class="gx-tk__reply-count">{{ replyContent.length }}/300</span>
              </div>
              <div class="gx-tk__reply-upload">
                <!-- 已上传的文件显示在方框内 -->
                <div v-for="(f, i) in replyFileList" :key="'thumb-'+i" class="gx-tk__reply-thumb">
                  <img v-if="isImage(f.url)" :src="f.url" alt="" @click="previewImg(f.url)" />
                  <span v-else class="gx-tk__reply-thumb-file" @click="downloadFile(f)">📄</span>
                  <button class="gx-tk__reply-thumb-del" @click="removeReplyFile(i)">
                    <svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M1 1l8 8M9 1L1 9" stroke="#fff" stroke-width="1.4" stroke-linecap="round" /></svg>
                  </button>
                </div>
                <!-- 添加按钮：未满5个时显示 -->
                <label v-if="replyFileList.length < 5" class="gx-tk__reply-add">
                  <input
                    type="file"
                    multiple
                    :accept="acceptTypes"
                    style="display:none"
                    @change="onReplyFilesChange"
                    :disabled="replyUploading"
                  />
                  <svg v-if="!replyUploading" width="18" height="18" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="#B0B0B5" stroke-width="1.4" stroke-linecap="round" /></svg>
                  <span v-else class="gx-tk__reply-uploading">...</span>
                </label>
                <span class="gx-tk__reply-upload-tip">{{ replyFileList.length }}/5张图片</span>
              </div>
              <div class="gx-tk__reply-actions">
                <button class="gx-tk__btn gx-tk__btn--primary gx-tk__btn--submit" :disabled="sending || (!replyContent.trim() && !replyAttachments.length)" @click="sendReply">{{ sending ? '提交中...' : '提交回复' }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览 -->
    <div v-if="previewUrl" class="gx-tk__preview" @click="previewUrl = ''">
      <img :src="previewUrl" alt="" />
    </div>
    <gx-loading :show="loading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import Pagination from '../../components/newUi/Pagination.vue'
import { uploadDirectOss } from '../../assets/js/utils/ossDirectUpload'

const ACCEPT_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/plain']

export default {
  name: 'NewTicketPage',
  components: { GxLoading, PageSizeSelect,Pagination },
  mixins: [gxLoading],
  data() {
    return {
      topTabs: [
        { id: 'list', label: '我的工单' },
        { id: 'create', label: '创建工单' },
        // { id: 'master', label: '工单管理' }
      ],
      topTab: 'list',
      statusTabs: [
        { label: '全部工单', status: '0', count: 0 },
        { label: '待处理', status: '1', count: 0 },
        { label: '处理中', status: '2', count: 0 },
        { label: '待确认', status: '3', count: 0 }
      ],
      statusMap: {
        0: '全部工单', 1: '待处理', 2: '处理中', 3: '待确认', 4: '已完成'
      },
      activeStatus: '0',
      searchData: { status: '', ticket_sn: '', title: '', timeRange: [] },
      timeStart: '',
      timeEnd: '',
      pageData: { limit: 10, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200],
      list: [],
      ismanager: false,
      // 创建工单
      createStep: 0,
      selectType: { id: 0, dictionary_name: '', remark: '' },
      typeList: [],
      form: { title: '', effect_no: '', user_mobile: '', content: '', attachments: [] },
      fileList: [],
      uploading: false,
      saving: false,
      // 详情
      detailShow: false,
      detailId: 0,
      ticketInfo: null,
      msgList: [],
      replyContent: '',
      replyAttachments: [],
      replyFileList: [],
      replyUploading: false,
      sending: false,
      previewUrl: '',
      acceptTypes: ACCEPT_TYPES.join(','),
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    canReply() {
      if (!this.ticketInfo) return false
      return [1, 2, 3].includes(this.ticketInfo.status)
    },
    isComfigReply() {
      if (!this.ticketInfo) return false
      return [1, 2].includes(this.ticketInfo.status)
    },
  },
  created() {
    this.ismanager = this.$store.state.login.userinfo && this.$store.state.login.userinfo.mer_user_id === '1'
    if (!this.ismanager) this.topTabs = this.topTabs.filter((t) => t.id !== 'master')
    this.getList(1)
  },
  methods: {
    ...mapActions({
      opGetUserTicket: 'ucenter/opGetUserTicket',
      opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
      opSaveUserTicket: 'ucenter/opSaveUserTicket',
      opGetTicketInfo: 'ucenter/opGetTicketInfo',
      opUpdateTicketStatus: 'ucenter/opUpdateTicketStatus',
      opSaveUserTicketMsg: 'ucenter/opSaveUserTicketMsg'
    }),
    switchTopTab(id) {
      if (id === 'create' && !this.typeList.length) this.loadTypes()
      this.topTab = id
      if (id !== 'create') {
        this.createStep = 0
        this.getList(1)
      }
    },
    loadTypes() {
      this.opGetDictionaryWords({
        data: { dictionary_type: 4 },
        success: (res) => {
          if (res.code === 200) {
            this.typeList = res.data || []
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    switchStatus(status) {
      this.activeStatus = status
      this.searchData.status = status === '0' ? '' : status
      this.getList(1)
    },
    onTimeChange() {
      this.getList(1)
    },
    search() {
      this.getList(1)
    },
    resetSearch() {
      this.searchData = { status: this.activeStatus === '0' ? '' : this.activeStatus, ticket_sn: '', title: '', timeRange: [] }
      this.timeStart = ''
      this.timeEnd = ''
      this.getList(1)
    },
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getList(1)
    },
    getList(page) {
      if (page) this.pageData.page = page
      const param = { page_size: this.pageData.limit, page: this.pageData.page }
      Object.assign(param, this.searchData)
      // if(this.timeStart&&this.timeEnd){
      //   param.timeRange = []
      //   if (this.timeStart) param.timeRange[0] = this.timeStart.replace('T', ' ')
      //   if (this.timeEnd) param.timeRange[1] = this.timeEnd.replace('T', ' ')
      // }
      if (this.topTab === 'master') param.ismanager = true
      this.loadingStart()
      this.opGetUserTicket({
        data: param,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.list = res.data.list || []
            this.pageData.total = res.data.total || 0
            const tabCount = res.data.ticketTabCount || {}
            this.statusTabs.forEach((t) => { t.count = tabCount[t.status] ?? 0 })
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    statusName(status) {
      return this.statusMap[status] || '未知'
    },
    statusClass(status) {
      const map = { 1: 'gx-tk__status--wait', 2: 'gx-tk__status--doing', 3: 'gx-tk__status--confirm', 4: 'gx-tk__status--done' }
      return map[status] || ''
    },
    statusTabClass(status) {
      const map = { 0: 'gx-tab__status--all', 1: 'gx-tab__status--wait', 2: 'gx-tab__status--doing', 3: 'gx-tab__status--confirm' }
      return map[status] || ''
    },
    nextStep() {
      if (!this.selectType.id) return
      this.createStep = 1
    },
    beforeUpload(file) {
      if (!ACCEPT_TYPES.includes(file.type)) {
        this.$message.error('仅支持 jpg、png、pdf、word、excel、txt 格式')
        return false
      }
      if (file.size / 1024 / 1024 >= 5) {
        this.$message.error('文件大小不能超过 5MB！')
        return false
      }
      return true
    },
    onFilesChange(e) {
      const files = Array.from(e.target.files || [])
      e.target.value = ''
      const remain = 5 - this.fileList.length
      if (remain <= 0) {
        this.$message.info('最多上传5个附件')
        return
      }
      if (files.length > remain) {
        this.$message.info(`最多上传5个附件，已自动截取前${remain}个`)
      }
      this.uploadFiles(files.slice(0, remain), 'create')
    },
    onReplyFilesChange(e) {
      const files = Array.from(e.target.files || [])
      e.target.value = ''
      this.uploadFiles(files, 'reply')
    },
    async uploadFiles(files, type) {
      const valid = files.filter((f) => {
        if (!this.beforeUpload(f)) return false
        return true
      })
      if (!valid.length) return
      const isReply = type === 'reply'
      if (isReply) this.replyUploading = true
      else this.uploading = true
      const pushFile = (info, name) => {
        const item = { url: info.url, object_name: info.object_name || name, suffix: info.suffix, storage_path: info.storage_path }
        if (isReply) {
          this.replyAttachments.push(item)
          this.replyFileList.push(item)
        } else {
          this.form.attachments.push(item)
          this.fileList.push(item)
        }
      }
      try {
        await Promise.all(valid.map(async (file) => {
          try {
            const data = await uploadDirectOss(file, { purpose: 'attachment' })
            if (!data.url) throw new Error('上传接口未返回文件地址')
            pushFile(data, file.name)
          } catch (error) {
            this.$message.error(error.message || '文件上传失败')
          }
        }))
      } finally {
        if (isReply) this.replyUploading = false
        else this.uploading = false
      }
    },
    removeFile(i) {
      this.form.attachments.splice(i, 1)
      this.fileList.splice(i, 1)
    },
    removeReplyFile(i) {
      this.replyAttachments.splice(i, 1)
      this.replyFileList.splice(i, 1)
    },
    isImage(url) {
      if (!url) return false
      const ext = url.split('.').pop().toLowerCase().split('?')[0]
      return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
    },
    previewImg(url) {
      this.previewUrl = url
    },
    downloadFile(item) {
      if (!item || !item.url) return
      const a = document.createElement('a')
      a.href = item.url
      a.download = item.object_name || 'file'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    submitTicket() {
      if (!this.form.title) {
        this.$message.info('请填写工单标题')
        return
      }
      if (!this.form.content) {
        this.$message.info('请描述问题详情')
        return
      }
      if (this.saving) return
      this.saving = true
      const params = {
        ticket_type: this.selectType.id,
        ticket_type_name: this.selectType.dictionary_name,
        title: this.form.title,
        effect_no: this.form.effect_no || '',
        user_mobile: this.form.user_mobile || '',
        content: this.form.content,
        attachments: this.form.attachments
      }
      this.opSaveUserTicket({
        data: params,
        success: (res) => {
          this.saving = false
          if (res.code === 200) {
            this.$message.success('工单反馈成功')
            this.form = { title: '', effect_no: '', user_mobile: '', content: '', attachments: [] }
            this.fileList = []
            this.selectType = { id: 0, dictionary_name: '', remark: '' }
            this.createStep = 0
            this.switchTopTab('list')
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    openDetail(row) {
      this.detailId = row.id
      this.detailShow = true
      this.loadDetail()
    },
    closeDetail() {
      this.detailShow = false
      this.ticketInfo = null
      this.msgList = []
    },
    loadDetail() {
      this.loadingStart()
      this.opGetTicketInfo({
        data: { ticketId: this.detailId },
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.ticketInfo = res.data || {}
            this.msgList = res.data.ticketmsg || []
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    sendReply() {
      if (this.sending) return
      if (!this.replyContent.trim() && !this.replyAttachments.length) return
      this.sending = true
      this.opSaveUserTicketMsg({
        data: { ticketId: this.detailId, replyContent: this.replyContent, attachments: this.replyAttachments },
        success: (res) => {
          this.sending = false
          if (res.code === 200) {
            this.replyContent = ''
            this.replyAttachments = []
            this.replyFileList = []
            this.loadDetail()
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    finishTicket(index) {
      let msg = "确定要完结该工单吗？"
      if (index == 3) {
        msg = "是否工单问题已解决，待用户确认？"
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opUpdateTicketStatus({
          data: { ticketId: this.detailId, status: index , 'ismanager': true},
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('工单状态修改成功')
              this.closeDetail()
              this.getList(this.pageData.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.gx-tk__tabs {
  display: flex;
  margin-bottom: 18px;
  border-bottom: 2px solid #E1E5EE;
}
.gx-tk__tab {
  padding: 9px 20px;
  border: none;
  background: #FFFFFF;
  cursor: pointer;
  font-size: 14px;
  color: #4A4A6A;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all .18s;
}
.gx-tk__tab--on {
  color: #C8443C;
  font-weight: 600;
  border-bottom-color: #C8443C;
}
.gx-tk__status-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}
.gx-tk__status-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-size: 14px;
  color: #4A4A6A;
  transition: all .2s;
}
.gx-tab__status--all{
  background: rgb(245, 245, 245);
  border: 0px solid rgb(224, 224, 236);
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 8px;
}
.gx-tab__status--wait{
  background: rgb(255, 247, 230);
  border: 0px solid rgb(255, 213, 145);
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 8px;
  color: rgb(251, 146, 60);
}
.gx-tab__status--doing{
  background: rgb(230, 244, 255);
  border: 0px solid rgb(145, 202, 255);
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 8px;
  color: rgb(22, 119, 255);
}
.gx-tab__status--confirm{
  background: rgb(255, 245, 245);
  border: 0px solid rgb(255, 204, 199);
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 8px;
  color: rgb(200, 68, 60);
}
.gx-tk__status-tab--on {
/*  border-color: rgba(200, 68, 60, .5);
  background: linear-gradient(180deg, rgba(200, 68, 60, .1), rgba(200, 68, 60, .02));
  color: #C8443C;
  font-weight: 600;*/
  transform: scale(1);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 8px 2px;
  border-width: 1px;
}
.gx-tk__status-num {
  font-family: 'JetBrains Mono', monospace;
  font-size: 22px;
  font-weight: 700;
}
.gx-tk__filter {
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 16px;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.gx-tk__flabel {
  font-size: 12px;
  color: #4A4A6A;
}
.gx-tk__flabel2 {
  display: block;
  font-size: 12px;
  color: #4A4A6A;
  margin-bottom: 6px;
}
.gx-tk__req {
  color: #F87171;
}
.gx-tk__input {
  height: 32px;
  padding: 0 10px;
  border-radius: 7px;
  border: 1px solid rgb(224, 224, 236);
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  background: #FFFFFF;
}
.gx-tk__input--mi{
  height: 28px;
  border-radius: 4px;
  border: 2px solid rgb(224, 224, 236);
  font-size: 11px;
}
.gx-tk__input--date {
  width: 170px;
}
.gx-tk__input--block {
  width: 100%;
  height: 36px;
}
.gx-tk__range-sep {
  color: #6A6A8A;
  font-size: 12px;
}
.gx-tk__spacer {
  flex: 1;
}
.gx-tk__btn {
  height: 32px;
  padding: 0 14px;
  border-radius: 7px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .2);
  font-size: 13px;
  color: #4A4A6A;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .16s;
}

.gx-tk__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-tk__btn--sm {
  height: 28px;
  padding: 0 12px;
  font-size: 12px;
}
.gx-tk__btn--mi{
  height: 26px;
  padding: 0px 9px;
  border-radius: 6px;
  font-size: 11px;
}
.gx-tk__btn--yellow{
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 199, 120));
  color: #ffffff;
}
.gx-tk__btn--primary {
    height: 32px;
    padding: 0px 20px;
    border-radius: 6px;
    cursor: pointer;
    background: linear-gradient(135deg, rgb(200, 68, 60), rgb(240, 117, 117));
    border: none;
    font-size: 13px;
    font-weight: 600;
    color: rgb(255, 255, 255);
    opacity: 1;
    box-shadow: rgba(255, 77, 79, 0.3) 0px 0px 12px;
}
.gx-tk__btn--add {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(240, 117, 117));
  color: rgb(255, 255, 255);
  font-size: 12px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}
.gx-tk__card {
  border-radius: 12px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  overflow: visible;
}
.gx-tk__table {
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  background: #FFFFFF;
}
.gx-tk__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-tk__table th {
  padding: 11px 14px;
  text-align: left;
  background: rgb(245, 240, 232);
  font-size: 11px;
  font-weight: 500;
  color: #6A6A8A;
  letter-spacing: .05em;
  text-transform: uppercase;
}
.gx-tk__table td {
  padding: 12px 14px;
  font-size: 13px;
  color: #1A1A2E;
  border-top: 1px solid rgba(212, 169, 70, .07);
}
.gx-tk__td-title {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-tk__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
}
.gx-tk__dim {
  color: rgb(153, 153, 153)!important;
}
.gx-tk__type-tag {
  padding: 3px 10px;
  border-radius: 5px;
  background: #E6F4FF;
  border: 1px solid #91CAFF;
  font-size: 11px;
  font-weight: 500;
  color: #1677FF;
}
.gx-tk__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 9px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 500;
}
.gx-tk__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.gx-tk__status--wait {
  color: #FA8C16;
}
.gx-tk__status--wait .gx-tk__status-dot { background: #FA8C16; }
.gx-tk__status--doing {
  color: #1677FF;
}
.gx-tk__status--doing .gx-tk__status-dot { background: #1677FF; }
.gx-tk__status--confirm {
  color: #4CAF7A;
}
.gx-tk__status--confirm .gx-tk__status-dot { background: #4CAF7A; }
.gx-tk__status--done {
  color: #6A6A8A;
}
.gx-tk__status--done .gx-tk__status-dot { background: #6A6A8A; }
.gx-tk__link {
    height: 26px;
    padding: 0px 10px;
    border-radius: 5px;
    cursor: pointer;
    background: rgb(230, 244, 255);
    border: 1px solid rgb(145, 202, 255);
    font-size: 11px;
    color: rgb(22, 119, 255);
    &:hover{
      background-color: rgb(22, 119, 255);
      color: #fff;
    }
}
.gx-tk__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #6A6A8A;
}
.gx-tk__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  border-top: 1px solid #E0E0EC;
  background: #F5F0E8;
  border-radius: 0 0 12px 12px;
  position: relative;
  z-index: 5;
}
.gx-tk__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-tk__pager-total {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-tk__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-tk__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-tk__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-tk__page--on {
  border: 1px solid rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  color: rgb(200, 68, 60);
  font-weight: 700;
}
.gx-tk__steps {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}
.gx-tk__step {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 7px;
}
.gx-tk__step-num {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #F0F2F8;
  border: 1px solid rgba(212, 169, 70, .25);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 700;
  color: rgb(106, 106, 138);
}
.gx-tk__step--on .gx-tk__step-num {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(240, 117, 117));
  border: 2px solid rgb(200, 68, 60);
  color: #fff;
}
.gx-tk__step--done .gx-tk__step-num {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(240, 117, 117));
  border: 2px solid rgb(200, 68, 60);
  color: #fff;
}
.gx-tk__step-label {
  font-size: 11px;
  color: #4A4A6A;
}

.gx-tk__step--on .gx-tk__step-label  {
    color: rgb(200, 68, 60);
}
.gx-tk__step--done .gx-tk__step-label {
  color: rgb(200, 68, 60);
}
.gx-tk__step-line {
  flex: 1;
  max-width: 800px;
  height: 2px;
  background: rgb(240, 240, 240);
  border-radius: 2px;
}
.gx-tk__step-line--on {
  background: rgb(200, 68, 60);
}
.gx-tk__type-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}
.gx-tk__type-title {
    font-size: 14px;
    font-weight: 600;
    color: rgb(26, 26, 46);
    margin-bottom: 14px;
}
.gx-tk__type-card {
  position: relative;
  /* border: 1px solid #E1E5EE;
  border-radius: 10px;
  padding: 16px 14px;
  cursor: pointer;
  background: #FFFFFF;
  transition: all .18s; */

  border-radius: 9px;
  padding: 14px 12px;
  cursor: pointer;
  text-align: center;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(224, 224, 236);
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1
}
.gx-tk__type-card:hover {
  background: rgb(255, 245, 245);
  border: 2px solid rgb(200, 68, 60);
  box-shadow: rgba(255, 77, 79, 0.15) 0px 2px 12px;
  .gx-tk__type-name {
    color: rgb(200, 68, 60)!important;
  }
  .gx-tk__type-desc {
    color: rgb(200, 68, 60)!important;
  }
}
.gx-tk__type-card--on {
  background: rgb(255, 245, 245);
  border: 2px solid rgb(200, 68, 60);
  box-shadow: rgba(255, 77, 79, 0.15) 0px 2px 12px;
  .gx-tk__type-name {
    color: rgb(200, 68, 60)!important;
  }
  .gx-tk__type-desc {
    color: rgb(200, 68, 60)!important;
  }
}
.gx-tk__type-check {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  border: 1.5px solid rgba(212, 169, 70, .3);
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-tk__type-card--on .gx-tk__type-check {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border-color: transparent;
}
.gx-tk__type-name {
  font-size: 13px;
  font-weight: 600;
  color: rgb(26, 26, 46);
  margin-bottom: 4px;
}
.gx-tk__type-icon{
  font-size: 28px;
  margin-bottom: 7px;
}
.gx-tk__type-desc {
  font-size: 10px;
  color: rgb(106, 106, 138);
  line-height: 1.5;
}
.gx-tk__type-empty {
  grid-column: 1 / -1;
}
/* 已选问题类型粉色条 */
.gx-tk__picked {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 18px;
  margin-bottom: 16px;
  background: #FFF5F5;
  border: 1px solid #FBDCDC;
  border-radius: 10px;
}
.gx-tk__picked-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.gx-tk__picked-icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFE3E3;
  border-radius: 6px;
  font-size: 16px;
}
.gx-tk__picked-name {
  font-size: 14px;
  font-weight: 700;
  color: #C8443C;
  flex-shrink: 0;
}
.gx-tk__picked-desc {
  font-size: 12px;
  color: #9A9AAA;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-tk__picked-reselect {
  flex-shrink: 0;
  background: #FFFFFF;
  border: 1px solid #F0B8B5;
  color: #C8443C;
  font-size: 12px;
  padding: 5px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all .16s;
}
.gx-tk__picked-reselect:hover {
  border-color: #C8443C;
}
/* 白色表单卡片 */
.gx-tk__form-card {
  background: #FFFFFF;
  border: 1px solid #E6E8F0;
  border-radius: 12px;
  padding: 20px 22px;
}
.gx-tk__field {
  margin-bottom: 18px;
}
.gx-tk__field--last {
  margin-bottom: 0;
}
.gx-tk__form-card .gx-tk__flabel2 {
  font-size: 13px;
  font-weight: 500;
  color: #1A1A2E;
}
.gx-tk__form-card .gx-tk__input--block {
  border-color: #E1E5EE;
  border-radius: 8px;
}
.gx-tk__textarea-wrap {
  position: relative;
}
.gx-tk__textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px 26px;
  border-radius: 8px;
  border: 1px solid #E1E5EE;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  font-family: 'Noto Sans SC', sans-serif;
  resize: vertical;
  min-height: 130px;
}
.gx-tk__textarea:focus {
  border-color: rgba(200, 68, 60, .5);
}
.gx-tk__textarea-count {
  position: absolute;
  right: 10px;
  bottom: 8px;
  font-size: 11px;
  color: #B0B0B5;
}
/* 创建工单附件上传 */
.gx-tk__create-upload {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.gx-tk__create-thumb {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  border: 1px solid #E1E5EE;
  overflow: hidden;
  background: #FAFAFA;
  flex-shrink: 0;
}
.gx-tk__create-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  display: block;
}
.gx-tk__create-thumb-file {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  cursor: pointer;
}
.gx-tk__create-thumb-del {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(0, 0, 0, .55);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.gx-tk__create-thumb-del:hover {
  background: rgba(0, 0, 0, .75);
}
.gx-tk__create-add {
  width: 64px;
  height: 64px;
  border: 1.5px dashed #D0D0D5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  background: #FAFAFA;
  flex-shrink: 0;
  transition: all .16s;
}
.gx-tk__create-add:hover {
  border-color: #C8443C;
  background: #FFF5F5;
}
.gx-tk__create-add-text {
  font-size: 11px;
  color: #9A9AAA;
}
.gx-tk__create-uploading {
  font-size: 12px;
  color: #9A9AAA;
}
.gx-tk__create-upload-tip {
  font-size: 13px;
  color: #9A9AAA;
}
.gx-tk__btn--back {
  gap: 4px;
}
.gx-tk__form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}
.gx-tk__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .35);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-tk__modal-box {
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow: auto;
  border-radius: 14px;
  background: #FFFFFF;
  box-shadow: 0 12px 40px rgba(0, 0, 0, .15);
}
.gx-tk__modal-box--wide {
  max-width: 760px;
}
.gx-tk__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 22px;
  border-bottom: 1px solid #EEE5D0;
  position: sticky;
  top: 0;
  z-index: 2;
  border-radius: 14px 14px 0 0;
  background: rgb(245, 240, 232);
}
.gx-tk__modal-head-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gx-tk__modal-head-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.gx-tk__modal-bar {
  display: inline-block;
  width: 3px;
  height: 16px;
  background: #C8443C;
  border-radius: 2px;
}
.gx-tk__modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-tk__modal-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid;
}
.gx-tk__modal-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.gx-tk__modal-status.gx-tk__status--wait {
  background: rgba(250, 140, 22, .08);
  border-color: rgba(250, 140, 22, .3);
  color: #FA8C16;
}
.gx-tk__modal-status.gx-tk__status--wait .gx-tk__modal-status-dot { background: #FA8C16; }
.gx-tk__modal-status.gx-tk__status--doing {
  background: rgba(22, 119, 255, .08);
  border-color: rgba(22, 119, 255, .3);
  color: #1677FF;
}
.gx-tk__modal-status.gx-tk__status--doing .gx-tk__modal-status-dot { background: #1677FF; }
.gx-tk__modal-status.gx-tk__status--confirm {
  background: rgba(76, 175, 122, .08);
  border-color: rgba(76, 175, 122, .3);
  color: #4CAF7A;
}
.gx-tk__modal-status.gx-tk__status--confirm .gx-tk__modal-status-dot { background: #4CAF7A; }
.gx-tk__modal-status.gx-tk__status--done {
  background: rgba(139, 157, 195, .08);
  border-color: rgba(139, 157, 195, .3);
  color: #6A6A8A;
}
.gx-tk__modal-status.gx-tk__status--done .gx-tk__modal-status-dot { background: #6A6A8A; }
.gx-tk__head-btn {
  height: 26px;
  padding: 0 9px;
  border-radius: 6px;
  border: 1.5px solid transparent;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  transition: all .18s;
}
/* 待确认工单：默认浅蓝描边，hover 实心蓝 */
.gx-tk__head-btn--primary {
  background: #E8F3FF;
  border-color: #69B1FF;
  color: #1677FF;
}
.gx-tk__head-btn--primary:hover {
  background: #1677FF;
  border-color: #1677FF;
  color: #FFFFFF;
}
/* 完结工单：默认白底灰边，hover 浅蓝 */
.gx-tk__head-btn--secondary {
  background: #FFFFFF;
  border-color: #DCE0E8;
  color: #4A4A6A;
}
.gx-tk__head-btn--secondary:hover {
  background: #F5F0E8;
}
.gx-tk__modal-close {
  background: #FFFFFF;
  border: 1.5px solid #DCE0E8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 5px;
  transition: all .18s;
}
.gx-tk__modal-close:hover {
  background: #F0F7FF;
  border-color: #69B1FF;
}
.gx-tk__modal-body {
  padding: 18px 22px 22px;
}
.gx-tk__detail {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.gx-tk__info-card {
    border-radius: 8px;
    background: rgb(245, 240, 232);
    border: 2px solid rgb(224, 224, 236);
    padding: 14px;
}
.gx-tk__info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 24px;
}
.gx-tk__info-row {
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 1.6;
}
.gx-tk__info-k {
  color: #8A8A9A;
  min-width: 72px;
  flex-shrink: 0;
}
.gx-tk__info-v {
  color: #1A1A2E;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.gx-tk__info-v--link {
  color: #1677FF;
}
.gx-tk__info-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}
.gx-tk__info-v.gx-tk__status--wait { color: #FA8C16; }
.gx-tk__info-v.gx-tk__status--wait .gx-tk__info-dot { background: #FA8C16; }
.gx-tk__info-v.gx-tk__status--doing { color: #1677FF; }
.gx-tk__info-v.gx-tk__status--doing .gx-tk__info-dot { background: #1677FF; }
.gx-tk__info-v.gx-tk__status--confirm { color: #4CAF7A; }
.gx-tk__info-v.gx-tk__status--confirm .gx-tk__info-dot { background: #4CAF7A; }
.gx-tk__info-v.gx-tk__status--done { color: #6A6A8A; }
.gx-tk__info-v.gx-tk__status--done .gx-tk__info-dot { background: #6A6A8A; }
.gx-tk__section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-tk__section-bar {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #C8443C;
  border-radius: 2px;
}
.gx-tk__section-count {
  font-size: 12px;
  font-weight: 400;
  color: #8A8A9A;
}
.gx-tk__chat-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
}
.gx-tk__chat-empty {
  padding: 30px 0 !important;
}
.gx-tk__chat-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.gx-tk__chat-head {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gx-tk__chat-name {
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-tk__chat-item--user .gx-tk__chat-name {
  color: #C8443C;
}
.gx-tk__chat-time {
  font-size: 11px;
  color: #9A9AAA;
}
.gx-tk__chat-bubble {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.6;
  color: #333;
}
.gx-tk__chat-item--user .gx-tk__chat-bubble {
    border-radius: 8px;
    background: rgb(255, 245, 245);
    border: 1px solid rgb(255, 204, 199);
}
.gx-tk__chat-item--agent .gx-tk__chat-bubble {
    border-radius: 8px;
    background: rgb(245, 245, 245);
    border: 1px solid rgb(224, 224, 236);
}
.gx-tk__chat-bubble p {
  margin: 0;
}
.gx-tk__chat-att {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 6px;
}
.gx-tk__att-img {
  width: 56px;
  height: 56px;
  border-radius: 5px;
  object-fit: cover;
  cursor: pointer;
  border: 1px solid #E1E5EE;
}
.gx-tk__att-file {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  border-radius: 5px;
  font-size: 12px;
  color: #1677FF;
  cursor: pointer;
}
.gx-tk__reply {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-tk__reply-textarea-wrap {
  position: relative;
}
.gx-tk__reply-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px 24px;
  border-radius: 8px;
  border: 1px solid #E0E0E0;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  font-family: 'Noto Sans SC', sans-serif;
  resize: none;
  background: #FFFFFF;
  transition: border-color .16s;
}
.gx-tk__reply-textarea:focus {
  border-color: rgb(200, 68, 60);
}
.gx-tk__reply-count {
  position: absolute;
  right: 10px;
  bottom: 6px;
  font-size: 11px;
  color: #B0B0B5;
}
.gx-tk__reply-upload {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.gx-tk__reply-thumb {
  position: relative;
  width: 68px;
  height: 68px;
  border-radius: 8px;
  border: 1px solid #E1E5EE;
  overflow: hidden;
  background: #FAFAFA;
  flex-shrink: 0;
}
.gx-tk__reply-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  display: block;
}
.gx-tk__reply-thumb-file {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
}
.gx-tk__reply-thumb-del {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(0, 0, 0, .55);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.gx-tk__reply-thumb-del:hover {
  background: rgba(0, 0, 0, .75);
}
.gx-tk__reply-add {
  width: 68px;
  height: 68px;
  border: 1.5px dashed #D0D0D5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #FAFAFA;
  flex-shrink: 0;
  transition: all .16s;
}
.gx-tk__reply-add:hover {
  border-color: #1677FF;
  background: #F0F7FF;
}
.gx-tk__reply-uploading {
  font-size: 12px;
  color: #9A9AAA;
}
.gx-tk__reply-upload-tip {
  font-size: 13px;
  color: #9A9AAA;
}
.gx-tk__reply-actions {
  display: flex;
  justify-content: flex-start;
}
.gx-tk__btn--submit {
  min-width: 90px;
  height: 34px;
  border-radius: 8px;
  font-size: 13px;
}
.gx-tk__preview {
  position: fixed;
  inset: 0;
  z-index: 800;
  background: rgba(0, 0, 0, .8);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}
.gx-tk__preview img {
  max-width: 80vw;
  max-height: 80vh;
  border-radius: 8px;
}
</style>
